// extracted by mini-css-extract-plugin
export default {"root":"File_root__isFhu","fullWidth":"File_fullWidth__5Z1UH","label":"File_label__NiGsQ","disabled":"File_disabled__xmKX+","input":"File_input__eboRG"};